import { router } from "@inertiajs/react"
import i18n, { changeLocale, type Locale } from "@/i18n"
import { useUiStore, type Theme } from "@/stores/ui-store"

export function saveLocalePreference(locale: Locale) {
  changeLocale(locale)
  router.patch("/account/preferences", { locale }, { preserveScroll: true })
}

export function saveThemePreference(theme: Theme) {
  useUiStore.getState().setTheme(theme)
  router.patch("/account/preferences", { theme }, { preserveScroll: true, preserveState: true })
}

export function applyAccountPreferences(locale: Locale | null, theme: Theme | null) {
  if (locale && locale !== (i18n.resolvedLanguage ?? i18n.language)) changeLocale(locale)
  const store = useUiStore.getState()
  if (theme && theme !== store.theme) store.setTheme(theme)
}
